export default __webpack_public_path__ + "static/media/CME-Builder-CodeListFile-Example.dd37a715.png";